import * as types from "./actionTypes";
import * as dayTypeApi from '../../api/dayTypeApi';

export function fetchDayTypeCalendar(resourceId, year, month, showFutureDays, userId) {
    return function (dispatch) {
        return dayTypeApi
            .getDayTypeCalendar(resourceId, year, month, showFutureDays, userId)
            .then(dayTypeCalendar => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_DAY_TYPE_CALENDAR_SUCCESS,
                    dayTypeCalendar
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function createDayType(parameters) {
    return function (dispatch) {
        return dayTypeApi
            .createDayType(parameters)
            .then(dayType => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.ADD_DAY_TYPE_SUCCESS,
                    dayType
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function editDayType(parameters) {
    return function (dispatch) {
        return dayTypeApi
            .updateDayType(parameters)
            .then(dayType => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.EDIT_DAY_TYPE_SUCCESS,
                    dayType
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function removeDayType(parameters) {
    return function (dispatch) {
        return dayTypeApi
            .deleteDayType(parameters)
            .then(dayType => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.REMOVE_DAY_TYPE_SUCCESS,
                    dayType
                });
            })
            .catch(error => {
                throw error;
            });
    };
}


export function fetchDayTypeSecurity(userId, dayTypeId) {
    return function (dispatch) {
        return dayTypeApi
            .getDayTypeSecurity(userId, dayTypeId)
            .then(dayTypeSecurity => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_DAY_TYPE_SECURITY_SUCCESS,
                    dayTypeSecurity
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function addResourceDayType(parameters) {
    return function (dispatch) {
        return dayTypeApi
            .createResourceDayType(parameters)
            .then(resourceDayType => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.ADD_RESOURCE_DAY_TYPE_SUCCESS,
                    resourceDayType
                });
            })
            .catch(error => {
                throw error;
            });
    };
}


export function fetchDayTypeRequestsByYear(resourceId, year, month) {
    return function (dispatch) {
        return dayTypeApi
            .getDayTypeRequestsByYear(resourceId, year, month)
            .then(dayTypeRequests => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_DAY_TYPE_REQUESTS_BY_YEAR,
                    dayTypeRequests
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchDayTypeRequestById(parameters) {
    return function (dispatch) {
        return dayTypeApi
            .getDayTypeRequestById(parameters)
            .then(dayTypeRequest => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_DAY_TYPE_REQUEST_BY_ID,
                    dayTypeRequest
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function editResourceDayType(parameters) {
    return function (dispatch) {
        return dayTypeApi
            .updateResourceDayType(parameters)
            .then(response => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.EDIT_RESOURCE_DAY_TYPE_SUCCESS,
                    response
                });
            })
            .catch(error => {
                throw error;
            });
    };
}
export function editResourceDayTypeComment(parameters) {
    return function (dispatch) {
        return dayTypeApi
            .updateResourceDayTypeComment(parameters)
            .then(response => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.EDIT_RESOURCE_DAY_TYPE_SUCCESS,
                    response
                });
            })
            .catch(error => {
                throw error;
            });
    };
}


export function fetchResourceDayTypeById(resourceDayTypeId) {
    return function (dispatch) {
        return dayTypeApi
            .getResourceDayTypeById(resourceDayTypeId)
            .then(resourceDayType => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_RESOURCE_DAY_TYPE_BY_ID_SUCCESS,
                    resourceDayType
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchResourceDayTypeByDate(resourceId, date) {
    return function (dispatch) {
        return dayTypeApi
            .getResourceDayTypeByDate(resourceId, date)
            .then(resourceDayType => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_RESOURCE_DAY_TYPE_BY_DATE_SUCCESS,
                    resourceDayType
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchDayTypesAll(isApprover, resourceId, date,userId) {
    return function (dispatch) {
        return dayTypeApi
            .getDayTypesAll(isApprover, resourceId, date,userId)
            .then(dayTypesAll => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_DAY_TYPES_ALL_SUCCESS,
                    dayTypesAll
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchDayTypesAllWithoutForceTour(params) {
    return function (dispatch) {
        return dayTypeApi
            .getDayTypesAllWithoutForceTour(params)
            .then(dayTypesAllWithoutForceTour => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_DAY_TYPES_ALL_WITHOUT_FORCE_TOUR_SUCCESS,
                    dayTypesAllWithoutForceTour
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function removeResourceDayTypes(resourceId, fromDate, toDate, userId) {
    return function (dispatch) {
        return dayTypeApi
            .deleteResourceDayTypes(resourceId, fromDate, toDate, userId)
            .then(response => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.REMOVE_RESOURCE_DAY_TYPE_SUCCESS,
                    response
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function removeResourceDayType(parameters) {
    return function (dispatch) {
        return dayTypeApi
            .deleteResourceDayType(parameters)
            .then(response => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.REMOVE_RESOURCE_DAY_TYPE_BY_ID_SUCCESS,
                    response
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchDayTypesByDayRule(parameters) {
    return function (dispatch) {
        return dayTypeApi
            .getDayTypesByDayRule(parameters)
            .then(dayTypes => {
                dispatch({
                    type: types.FETCH_DAY_TYPES_BY_DAY_RULE,
                    dayTypes
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function fetchDayTypesAllowingTourScheduling(parameters) {
    return function (dispatch) {
        return dayTypeApi
            .getDayTypesAllowingTourScheduling(parameters)
            .then(dayTypes => {
                dispatch({
                    type: types.FETCH_DAY_TYPES_ALLOWING_TOUR_SCHEDULING,
                    dayTypes
                });
            })
            .catch(error => {
                throw error;
            });
    };
}

export function updateDayTypeCalendarScheduleParameters(parameters) {
    return function (dispatch) {
      dispatch({
        type: types.EDIT_DAY_TYPE_CALENDAR_SCHEDULE_PARAMETERS_SUCCESS,
        parameters
      });
    }
}

export function fetchIfHasHolidaySchedule(parameters) {
    return function (dispatch) {
        return dayTypeApi
            .getHasHolidays(parameters)
            .then(ifHasHolidaySchedule => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_IF_HAS_HOLIDAY_SCHEDULE_SUCCESS,
                    ifHasHolidaySchedule
                });
            })
            .catch(error => {
                throw error;
            });
    };
}




// WEBPACK FOOTER //
// ./src/redux/actions/dayTypeActions.js